import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getCurrencySymbol } from '@angular/common';
import { TokenStorageService } from 'src/app/core/auth/token-storage.service';
import { ConfirmationDialogBoxComponent } from 'src/app/shared/components/dialog-box';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';
import { LoyaltyExpiryConfiguration, WalletExpiryConfiguration } from 'src/app/shared/models/model';
import { WalletExpiryConfigurationComponent } from 'src/app/shared/components/wallet-expiry-configuration/wallet-expiry-configuration.component';

@Component({
  selector: 'app-badge-create',
  templateUrl: './badge-create.component.html',
  styleUrls: ['./badge-create.component.css']
})
export class BadgeCreateComponent implements OnInit {

  constructor(
    private dialogRefer: MatDialogRef<BadgeCreateComponent>,
    private dialog: MatDialog,
    private _apicall: ApiCallService,
    private _snackBar: SnackbarCollection,
    private tokenStorage: TokenStorageService,
    private _i18nDynamicTranslate: TranslateDynamicText,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  @ViewChild("offerBudgetComp") offerBudgetComp: any;


  revCurrency;
  currencySymbol;
  walletExpiryConfiguration: WalletExpiryConfiguration = {
      expiryType: "DEFAULT",
      duration: {
        value: 0,
        unit: "DAYS",
      },
      validityDate: "",
      defaultExpiry: true,
      noExpiry: false
    };
    loyaltyExpiryConfig: LoyaltyExpiryConfiguration = {
            expiryType: "DEFAULT",
            duration: 0,
            timeFrame: "DAYS",
            validityDate: "",
            defaultExpiry: true
    };
    @ViewChild("badgeWalletConfig")
    badgeWalletConfig: WalletExpiryConfigurationComponent;
    @ViewChild("profileLoyaltyConfig")
    profileLoyaltyConfig: WalletExpiryConfigurationComponent;
    
  ngOnInit(): void {
    this.revCurrency = sessionStorage.getItem("serviceCurrency");
    this.currencySymbol = getCurrencySymbol(this.revCurrency, "narrow");
    if(this.data.mode == 'edit' || this.data.mode == 'clone') {
      this.getBadge(this.data.id,true,true,true);
    }
    this.getOfferTemplates();
    this.getLoyaltyConfig();
    this.getLedgerList();
  }

  closedialog(action) {
    if(action == 'refreshList') {
      this.dialogRefer.close(true)
    } else {
      this.dialogRefer.close(false);
    }
  }


  badgeConfig = {
    id: null,
    name: "",
    description  : "",
    badgeNameAlias : "",
    descriptionAlias: "",
    badgeImageUrl : null,
    bannerImageUrl : null,
    rewards : [],
    perCustomerBadgeAssignmentLimit: null,
    budgetEntity:null,
    customerCountWithThisBadge:null,
    activeStrategiesWithBadge:null,
    activeChallengesWithBadge:null,
  };

  dataLoading = false;
  isEditDisabled = false;
  disableEditText = '';
  badgeConfigBeforeEdit = null;
  getBadge(id,showCustomerCount?,showActiveStrategies?,showActiveChallenges?) {
    this.dataLoading = true;
    this._apicall.getBadge(id,showCustomerCount,showActiveStrategies,showActiveChallenges).subscribe(
      (response)=>{
        if(response['body']) {
          this.badgeConfig = response['body'];
          this.badgeConfig.rewards = JSON.parse( response['body'].rewards);

          //disable edit if
          if(this.data.mode == 'edit') {
            if(this.badgeConfig.customerCountWithThisBadge > 0) {
              this.isEditDisabled = true;
              this.disableEditText = "as badge is assigned to customer";
            }
            if(this.badgeConfig.activeStrategiesWithBadge.length > 0) {
              this.isEditDisabled = true;
              this.disableEditText = `badge is attached to active Journey [${this.badgeConfig.activeStrategiesWithBadge}]`;
            }
            if(this.badgeConfig.activeChallengesWithBadge.length > 0) {
              this.isEditDisabled = true;
              this.disableEditText = `badge is attached to active Challenge [${this.badgeConfig.activeChallengesWithBadge}]`;
            }
            this.badgeConfigBeforeEdit = {...this.badgeConfig};
          }
          if(this.data.mode == 'clone') {
            this.badgeConfig.name = this.addClonedSuffix(this.badgeConfig.name);
          }
          this.dataLoading = false;
          if(this.badgeConfig.budgetEntity) {
            this.hasBudget = true;
            this.budgetEntity = this.badgeConfig.budgetEntity;
          }
          this.prefillRewards();
        }
      },
      (error)=>{
        this.dataLoading = false;
        this._snackBar.openSnackBar('Error fetching config data '+error.error, 2000);
      }
    );
  }

  addClonedSuffix(name) {
    let maxLength = 50;
    let suffix = "-Cloned";
    let maxBaseNameLength = maxLength - suffix.length;
    return name.length <= maxBaseNameLength?name + suffix: name.substring(0, maxBaseNameLength).trim() + suffix;
  }

  hasLoyaltyConfig = false;
  getLoyaltyConfig() {
    this._apicall.getLoyaltyProgramConfig().subscribe(
      response=>{
        let loyaltyProgramConfig = response['body'];
        if(loyaltyProgramConfig && !loyaltyProgramConfig.partialUpdate) {
          this.hasLoyaltyConfig = true; 
        }
      },
      error=>{
        this._snackBar.openSnackBar("Error fetching loyalty config data "+error.error, 4000);
      }
    );
  }

  ledgerList = [];
  getLedgerList() {
    this._apicall.getLedgerList().subscribe(
      response=> {
        this.ledgerList = response['body'].ledgerList;
        if(this.ledgerList.length > 0 ) {
          this.selectedLedgerId = !this.selectedLedgerId?this.ledgerList[0].id:this.selectedLedgerId;
        }
      },
      error => {
        this._snackBar.openSnackBar("Error fetching ledger data "+error.error, 4000);
      }
    );
  }

  
  offerList = [];
  offersLoading = false;
  getOfferTemplates() {
    this.offersLoading = true;
    this._apicall.getAllOfferList().subscribe(
      (response) => {
        if (response["message"] === "success") {
          this.offerList = (response["body"]).offers;
          
          this.offerList = this.offerList.length > 0
          ? this.offerList
              .filter(offer => offer.status.toLowerCase() === 'draft')  // Only include drafts
              .map(offer => ({
                ...offer,
                checked: false,    
                disabled: false,   
              }))
          : this.offerList;
          this.offersLoading = false;
        }
        if(this.data.mode == 'edit' || this.data.mode == 'clone') {
          this.prefillRewards();
        }
      },
      (err) => {
        this.offersLoading = false;
        this._snackBar.openSnackBar("Error fetching offer data "+err.error, 4000);
        console.log(err);
      }
    );
  }


  uploading1 = false;
  uploading2 = false;
  setUploadedFile(event: Event, imageType: string) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    if (imageType === 'primary') {
        this.uploading1 = true;
    } else if (imageType === 'secondary') {
        this.uploading2 = true;
    }

    const fd = new FormData();
    fd.append("files", input.files[0], input.files[0].name);

    this._apicall.uploadBadgeImg(fd, imageType).subscribe(
        response => {
            if (imageType === 'primary') {
                this.uploading1 = false;
                this.badgeConfig.badgeImageUrl = response["body"][0] + '?v=' + Date.now();
            } else if (imageType === 'secondary') {
                this.uploading2 = false;
                this.badgeConfig.bannerImageUrl = response["body"][0] + '?v=' + Date.now();
            }

            // Reset file input to allow uploading the same file again
            input.value = '';
        },
        error => {
            this._snackBar.openSnackBar("Error uploading image "+error.error, 4000);
            this.uploading1 = false;

            // Reset file input in case of error
            input.value = '';
        }
    );
}

  prefillRewards() {
    for(let reward of this.badgeConfig.rewards) {
      if(reward.type == 'offer') {
        let reqOfferIndex = this.offerList.findIndex((offer) => offer.id == reward.id);
        if (reqOfferIndex !== -1) {
          let reqOffer = this.offerList[reqOfferIndex];
          reqOffer.checked = true;
          this.selectedOffers.push(reqOffer);
          // Remove reqOffer from its current position
          this.offerList.splice(reqOfferIndex, 1);
          // Add reqOffer to the front of the offerList
          this.offerList.unshift(reqOffer);
        }
        this.checkRewardType({checked:true},'OFFER');
      }
      if(reward.type == 'loyalty_points') {
        this.loyaltyPointsValue = reward.value;
        this.loyaltyExpiryConfig = reward.loyaltyPointsExpiry;
        this.checkRewardType({checked:true},'LP');
      }
      if(reward.type == 'wallet_cashback') {
        this.cashBackValue = reward.value;
        this.selectedLedgerId = reward.ledgerId;
        this.walletExpiryConfiguration = reward.programExpWalletConfig;
        this.checkRewardType({checked:true},'WC');
      }
    }
  }

  rewardTypesSelected = {
    OFFER: false,
    LP: false,
    WC: false,
  }
  checkRewardType(event,checkBoxName) {
    this.errorFieldList = [];
    if(event.checked) {
      this.rewardTypesSelected[checkBoxName] = true;
    } else {
      if(checkBoxName == 'OFFER') {
        this.clearOfferCheckboxes();
      }
      if(checkBoxName == 'LP') {
        this.loyaltyPointsValue = null;
      }
      if(checkBoxName == 'WC') {
        this.cashBackValue = null;
        this.selectedLedgerId = this.ledgerList[0].id;
      }
      this.rewardTypesSelected[checkBoxName] = false;
    }
  }

  clearOfferCheckboxes() {
    if(this.selectedOffers.length>0) {
      for(let offer of this.selectedOffers) {
        offer.checked = false;
      }
      this.selectedOffers = [];
    } else {
      this.selectedOffers = [];
    }
  }

  offerSearch = '';
  getFilteredOffers() {
    return this.offerList.filter((offer) => offer.offerName.toLowerCase().includes(this.offerSearch.toLowerCase()));
  }

  cashBackValue;
  selectedLedgerId;
  loyaltyPointsValue;
  selectedOffers = [];
  selectOffer(event,offer) {
    this.errorFieldList = [];
    if(event.checked) {
      this.selectedOffers.push(offer);
      offer.checked = true;
    } else {
      this.selectedOffers = this.selectedOffers.filter((offer1) => offer1.id != offer.id);
      offer.checked = false;
    }
  }

  addSelectedRewardToRewards() {
    this.badgeConfig['rewards'] = [];
    if(this.selectedOffers.length > 0) {
      for(let offer of this.selectedOffers) {
        this.badgeConfig['rewards'].push({
          type: 'offer',
          id: offer.id,
          name: offer.offerName,
        });
      }
      this.selectedOffers = [];
    }  
    if(this.loyaltyPointsValue > 0){
      if(this.loyaltyExpiryConfig){
        this.loyaltyExpiryConfig.validityDate = this.loyaltyExpiryConfig.validityDate?.replace("T", " ");
      } 
      this.badgeConfig['rewards'].push({
        type: 'loyalty_points',
        value: this.loyaltyPointsValue,
        id: this.generateRandomString(10),
        loyaltyPointsExpiry: this.loyaltyExpiryConfig,
      });
    }
    if(this.cashBackValue > 0){
      this.badgeConfig['rewards'].push({
        type: 'wallet_cashback',
        value: this.cashBackValue,
        id: this.generateRandomString(10),
        ledgerId : this.selectedLedgerId,
        programExpWalletConfig: (this.walletExpiryConfiguration),
      });
    }
    this.errorFieldList = [];
  }

  generateRandomString(length) {
    const characters = '123456789abcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  deleteReward(reward) {
    if(reward.type == 'OFFER') {
      let reqOffer = this.offerList.find((offer)=>offer.id == reward.id);
      if(reqOffer) {
        reqOffer.disabled = false;
        reqOffer.checked = false;
      }
      this.badgeConfig.rewards = this.badgeConfig.rewards.filter((reward2)=>reward2.id != reward.id);
    } else {
      this.badgeConfig.rewards = this.badgeConfig.rewards.filter((reward2)=>reward2.id != reward.id);
    }
    this.errorFieldList = [];
  }

  hasBudget = false;
  budgetEntity = null;
  onHasBudgetChange() {
    if (!this.hasBudget) {
      this.badgeConfig.budgetEntity = null;
      this.budgetEntity = null;
      this.offerBudgetComp.resetValues();
    }
  }

  cleanTextInput() {
    this.badgeConfig.name = this.badgeConfig.name?.trim();
    this.badgeConfig.description = this.badgeConfig.description?.trim();
    this.badgeConfig.badgeNameAlias = this.badgeConfig.badgeNameAlias?.trim();
    this.badgeConfig.descriptionAlias = this.badgeConfig.descriptionAlias?.trim();
  }

  errorFieldList = [];
  isConfigValid() {
    this.errorFieldList = [];
    this.cleanTextInput();
    if(!this.badgeConfig.name.trim()) {
      this.errorFieldList = [...this.errorFieldList,'NAME'];
    }
    if(this.rewardTypesSelected['WC'] ){
      this.walletExpiryConfiguration = this.badgeWalletConfig.getExpirationData();
    }
    if(this.rewardTypesSelected['LP'] ){
      this.loyaltyExpiryConfig = this.profileLoyaltyConfig.getExpirationData();
    }
    if(!this.badgeConfig.perCustomerBadgeAssignmentLimit) {
      this.errorFieldList = [...this.errorFieldList,'PCBA'];
    }
    if(this.rewardTypesSelected['OFFER'] && this.selectedOffers.length == 0) {
      this.errorFieldList = [...this.errorFieldList,'OFFER'];
    }

    if(this.rewardTypesSelected['LP'] && (!this.loyaltyPointsValue || this.loyaltyExpiryConfig == null)) {
      this.errorFieldList = [...this.errorFieldList,'LP'];
    }

    if(this.rewardTypesSelected['WC'] && (!this.cashBackValue || this.walletExpiryConfiguration == null)) {
      this.errorFieldList = [...this.errorFieldList,'WC'];
    }
    if(this.hasBudget) {
      if(!this.offerBudgetComp.isValuesValid()) {
        this.errorFieldList = [...this.errorFieldList,'BUDGET'];
      }
      this.badgeConfig.budgetEntity = this.offerBudgetComp.returnBudgetObj();
      if(this.isEditDisabled && this.badgeConfig.budgetEntity.redemptionCount < this.badgeConfigBeforeEdit.budgetEntity.redemptionCount) {
        this.errorFieldList = [...this.errorFieldList,'BE'];
      }
    }
    if(this.isEditDisabled && this.badgeConfig.perCustomerBadgeAssignmentLimit < this.badgeConfigBeforeEdit.perCustomerBadgeAssignmentLimit) {
      this.errorFieldList = [...this.errorFieldList,'PCBA2'];
    }
    if(this.errorFieldList.length>0) {
      this.scrollToErrorField();
      return false;
    }
    return true;
  }

  scrollToErrorField() {
    setTimeout(() => {
      const errorField = document.querySelector('.error-text');
      if (errorField) {
          errorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 250);
  }

  isSaving = false;
  saveConfig() {
    if(this.isConfigValid()) {
      this.addSelectedRewardToRewards();
      let reqBody = { ...this.badgeConfig, rewards: JSON.stringify(this.badgeConfig.rewards) };
      if(this.hasBudget) {
        let budgetEntityFromComp = this.offerBudgetComp.returnBudgetObj();
        budgetEntityFromComp['merchantId'] = parseInt(this.tokenStorage.getMerchantId());
        budgetEntityFromComp['module'] = 'BADGE';
        budgetEntityFromComp['moduleId'] = null;
        reqBody['budgetEntity'] = budgetEntityFromComp;
      }
      if(this.data.mode == 'create' || this.data.mode == 'clone') {
        if(this.data.mode == 'clone') {
          delete reqBody['id'];
        }
        this.isSaving = true;
        this._apicall.createBadge(reqBody).subscribe(
          (response)=>{
            setTimeout(()=>{
              this.isSaving = false;
              this._snackBar.openSnackBar("Created Badge", 2000);
              this.closedialog('refreshList');
            },500);
          },
          (error)=>{
            this.isSaving = false;
            this._snackBar.openSnackBar(error.error, 4000);
            if(error.error.includes('name already')) {
              this.errorFieldList = [...this.errorFieldList,'NAMEEXIStS'];
              this.scrollToErrorField();
            }
          }
        );
      } 
      else {
        let reqBody = { ...this.badgeConfig, rewards: JSON.stringify(this.badgeConfig.rewards) };
        if(this.hasBudget) {
          let budgetEntityFromComp = this.offerBudgetComp.returnBudgetObj();
          budgetEntityFromComp['merchantId'] = parseInt(this.tokenStorage.getMerchantId());
          budgetEntityFromComp['module'] = 'BADGE';
          budgetEntityFromComp['moduleId'] = this.badgeConfig.id;
          reqBody['budgetEntity'] = budgetEntityFromComp;
        } else {
          reqBody['budgetEntity'] = null;
        }
        if(this.isEditDisabled) {
          const tempDialogRef = this.dialog.open(
            ConfirmationDialogBoxComponent,
            {
              panelClass: "no-padding-dialog-popup",
              width: "280px",
              data: {
                subject: `Save confirmation?`,
                message: `${this.disableEditText}. Are you sure you want to save changes?`,
                cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", ['POS_PAGE']),
                successButtonText: this._i18nDynamicTranslate.transform("Confirm", ['POS_PAGE']),
              }
            }
          );
          tempDialogRef.afterClosed().subscribe((result) => {
            if(result) {
              this.updateBadge(reqBody);
            }
          });
        } else {
          this.updateBadge(reqBody);
        }
      }
    }
  }

  updateBadge(reqBody){
    this.isSaving = true;
    this._apicall.updateBadge(this.data.id,reqBody).subscribe(
      (response)=>{
        setTimeout(()=>{
          this.isSaving = false;
          this._snackBar.openSnackBar("Updated Badge", 2000);
          this.closedialog('refreshList');
        },500);
      },
      (error)=>{
        this.isSaving = false;
        this._snackBar.openSnackBar(error.error, 4000);
        if(error.error.includes('name already')) {
          this.errorFieldList = [...this.errorFieldList,'NAMEEXIStS'];
          this.scrollToErrorField();
        }
      }
    );
  }

  numberInputHandler(event: KeyboardEvent,maxLength,inputType?) {

    const inputValue = (event.target as HTMLInputElement).value;
    const decimalPlaces = 2;
    if (inputType.toLowerCase() != 'float') {
      const invalidCharacters = ['e', '-', '+', '.'];
      if ((inputValue.length >= maxLength && event.key !== 'Backspace') || invalidCharacters.includes(event.key)) {
        event.preventDefault();
      }
    } else {
      const invalidCharacters = ['e', '-', '+']
      const dotIndex = inputValue.indexOf('.');
      if (dotIndex !== -1 && inputValue.substring(dotIndex + 1).length >= decimalPlaces && event.key !== 'Backspace') {
        event.preventDefault();
      } else {
        if ((inputValue.length >= maxLength && event.key !== 'Backspace') || invalidCharacters.includes(event.key)) {
          event.preventDefault();
        }
      }
    }
  }

  disableWheelScroll(event: WheelEvent): void {
    event.preventDefault();
  }


}
